import { trans } from '@lingoda/i18n';
import { DialogInfo } from '../feedback';
import { Typography } from '../layout';
import DangerousHtml from '../layout/DangerousHtml';

interface Props {
    title?: string;
    message: string;
    buttonLabel?: string;
    hideDialog: () => void;
}

export const GenericInfoMessageDialog = ({
    title,
    message,
    hideDialog,
    buttonLabel = trans('btn-acknowledge', {}, 'public-common'),
}: Props) => {
    return (
        <DialogInfo isOpen onClose={hideDialog} buttonLabel={buttonLabel} title={title}>
            <Typography variant="body1">
                <DangerousHtml>{message}</DangerousHtml>
            </Typography>
        </DialogInfo>
    );
};
